import { Navigate } from "react-router-dom";
import { removeAuthData } from "utils/storage";

const Logout = () => {
    removeAuthData();
    return <Navigate to={'/login'} />;
}

export default Logout;